module.exports = "/packs/images/homepage/activity/football_desktop~b1bbc4de7bdd551858f3de93e4293aa4.jpg";